/**
 * Simple cache relate osmIds to Places which have been resolved this session.
 *
 * Used to prevent accidentally POSTing the same osmId twice while retrying a request.
 */
// TODO: Figure out where to put this
const cache = {};

const setItem = (osmUid
/*: string*/
, place
/*: Place*/
) => {
  cache[osmUid] = place;
};

const getItem = (osmUid
/*: string*/
) => cache[osmUid];

module.exports = {
  setItem,
  getItem
};